// extracted by mini-css-extract-plugin
module.exports = {"GlobalLoader":"GlobalLoader_GlobalLoader__1Pu5H"};